module.exports = __webpack_public_path__ + "static/media/qanelas.dfcb3fff.otf";